import { Component, DestroyRef, inject, signal, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  standalone: true,
  imports: [MatIconModule],
  selector: 'iot-platform-success-snack-bar',
  templateUrl: './success-snack-bar.component.html',
  styles: [
    `
      .mat-mdc-snack-bar-container.iot-snack-success .mdc-snackbar__surface {
        background: transparent !important;
        box-shadow: none !important;
        padding: 0 !important;
        min-width: 0 !important;
      }
      .mat-mdc-snack-bar-container.iot-snack-success .mat-mdc-snack-bar-label {
        padding: 0 !important;
      }
      .snack-progress-bar {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 2px;
        width: 100%;
        background-color: #6ee7b7;
        animation: snack-drain 4s linear forwards;
      }
      .snack-paused .snack-progress-bar {
        animation-play-state: paused;
      }
      @keyframes snack-drain {
        from {
          width: 100%;
        }
        to {
          width: 0%;
        }
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})
export class SuccessSnackBarComponent {
  readonly snackBarRef = inject<MatSnackBarRef<SuccessSnackBarComponent>>(MatSnackBarRef);
  readonly data: { message: string; duration: number } = inject(MAT_SNACK_BAR_DATA);

  readonly paused = signal(false);
  private timer: ReturnType<typeof setTimeout> | null = null;
  private startTime = 0;
  private remaining = this.data.duration;

  constructor() {
    inject(DestroyRef).onDestroy(() => this.clearTimer());
    this.startTimer();
  }

  onMouseEnter(): void {
    this.paused.set(true);
    this.remaining -= Date.now() - this.startTime;
    this.clearTimer();
  }

  onMouseLeave(): void {
    this.paused.set(false);
    this.startTimer();
  }

  private startTimer(): void {
    this.startTime = Date.now();
    this.timer = setTimeout(() => this.snackBarRef.dismiss(), this.remaining);
  }

  private clearTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
